export default {
    AttachmentComposeSPLinksCanNotShareInternally: {
        datapoint: { name: 'AttachmentComposeSPLinksCanNotShareInternally' },
    },
    AttachmentComposeSPLinks: { datapoint: { name: 'AttachmentComposeSPLinks' } },
    AttachmentComposeSPMySiteLinks: { datapoint: { name: 'AttachmentComposeSPMySiteLinks' } },
    AttachmentComposeSPLinksShouldReplaceText: {
        datapoint: { name: 'AttachmentComposeSPLinksShouldReplaceText' },
    },
    AttachmentComposeSPLinksResponseHasValidFileName: {
        datapoint: { name: 'AttachmentComposeSPLinksResponseHasValidFileName' },
    },
    AttachmentComposeSPLinksFromPaste: { datapoint: { name: 'AttachmentComposeSPLinksFromPaste' } },
    AttachmentComposeSPLinksFromSetContent: {
        datapoint: { name: 'AttachmentComposeSPLinksFromSetContent' },
    },
    AttachmentComposeSPLinkRemove: { datapoint: { name: 'AttachmentComposeSPLinkRemove' } },
    AttachmentComposeUnderTenSPLinksFromAnchorElements: {
        datapoint: { name: 'AttachmentComposeUnderTenSPLinksFromAnchorElements' },
    },
    AttachmentComposeAtLeastTenSPLinksFromAnchorElements: {
        datapoint: { name: 'AttachmentComposeAtLeastTenSPLinksFromAnchorElements' },
    },
    ComposeEditorIsNullDuringProcessSPLinks: {
        datapoint: {
            name: 'ComposeEditorIsNullDuringProcessSPLinks',
            customData: function (linkCount, totalLinkCount, totalTime) { return [
                linkCount,
                totalLinkCount,
            ]; },
        },
    },
    GetSharingInformationFailure: {
        datapoint: {
            name: 'GetSharingInformationFailure',
            customData: function (error) { return [null]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map